var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconarrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51792 11C6.29519 11 6.18365 10.7307 6.34114 10.5732L10.6769 6.23751C10.9697 5.94462 10.9697 5.46975 10.6769 5.17685L10.3233 4.8233C10.0304 4.53041 9.55553 4.53041 9.26264 4.8233L3.01264 11.0733C2.87199 11.214 2.79297 11.4047 2.79297 11.6036V12.3965C2.79297 12.5954 2.87199 12.7862 3.01264 12.9269L9.26264 19.1769C9.55553 19.4697 10.0304 19.4697 10.3233 19.1769L10.6769 18.8233C10.9697 18.5304 10.9697 18.0555 10.6769 17.7626L6.34099 13.4268C6.1835 13.2693 6.29504 13 6.51777 13H19.75C20.1642 13 20.5 12.6642 20.5 12.25V11.75C20.5 11.3358 20.1642 11 19.75 11H6.51792Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowleft);
export default __webpack_public_path__ + "static/media/icon.arrow.left.f32fd7fc25c5aa0b8c5f6e5b83a507b8.svg";
export { ForwardRef as ReactComponent };